// /**
//  * @see https://umijs.org/docs/max/access#access
//  * */
// export default function access(
//   initialState: { currentUser?: API.CurrentUser } | undefined,
// ) {
//   const { currentUser } = initialState ?? {};
//   return {
//     canAdmin: currentUser && currentUser.access === 'admin',
//   };
// }
export default function access(initialState: { currentUser?: any } | undefined) {
  const { currentUser } = initialState ?? {};
  if (!currentUser) return { isAdmin: true, isGuardian: true, isStudent: true };

  return {
    isAdmin: currentUser?.userType === 'SUPER_ADMIN',
    isGuardian: currentUser?.userType === 'GUARDIAN',
    isStudent: currentUser?.userType === 'STUDENT',
  };
}